<template>
  <form id="emailTemplateModal">
    <b-modal
      v-model="show"
      size="xl"
      hide-header
      hide-footer
      centered
      @hide="hideModal"
    >
      <div class="modal-body d-flex email-content p-0">
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="!loading"
            key="content"
            v-html="$sanitize(emailTemplate, sanitizerSettings)"
          >
          </div>
          <div
            v-else
            key="spinner"
            class="m-auto"
          >
            <b-spinner />
          </div>
        </transition>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="button"
          @click="hideModal"
        >
          Закрыть
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
export default {
  name: 'EmailTemplateModal',
  props: {
    value: Boolean,
    emailId: String,
  },
  data: vue => ({
    show: false,
    loading: false,
    emailTemplate: null,
    sanitizerSettings: {
      allowedTags: vue.$sanitize.defaults.allowedTags.concat(['img', 'title']),
      allowedSchemes: vue.$sanitize.defaults.allowedSchemes.concat(['data']),
      allowedAttributes: {
        ...vue.$sanitize.defaults.allowedAttributes,
        '*': ['style', 'class', 'colspan', 'rowspan'],
        a: ['href', 'target', 'name', 'data-*'],
      },
    },
  }),
  watch: {
    value(val) {
      this.show = val;

      if (val) {
        this.getEmailTemplate();
      }
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
    async getEmailTemplate() {
      this.loading = true;
      this.emailTemplate = await this.$http.get(`mailer/1.0/mail/${this.emailId}/html`);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}

.email-content {
  padding: 0;
  word-break: break-word;
  min-height: 40vh;
}
</style>
